import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import Profile from "./pages/Profile";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Login from "./pages/Login";
import PrivateRoute from "./components/common/PrivateRoute";
import InstallPWA from "./components/InstallPWA";

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-gray-50">
        <Routes>
          {/* Ruta Pública - Login sin header/footer */}
          <Route path="/login" element={<Login />} />

          {/* Rutas Protegidas - Con header y footer */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <div className="flex flex-col min-h-screen">
                  <Header />
                  <main className="flex-1 flex flex-col">
                    <HomePage />
                  </main>
                  <Footer />
                </div>
              </PrivateRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <div className="flex flex-col min-h-screen">
                  <Header />
                  <main className="flex-1 flex flex-col">
                    <Profile />
                  </main>
                  <Footer />
                </div>
              </PrivateRoute>
            }
          />

          {/* Ruta por defecto */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>

        {/* PWA Install Button */}
        <InstallPWA />
      </div>
    </Router>
  );
}

export default App;
